export const getCookie = (name) =>
  document.cookie
    .split("; ")
    .find((el) => el.startsWith(`${name}=`))
    ?.split("=")[1];

export const setCookie = ({ key, value = "", age = 24 * 60 * 60 }) => {
  document.cookie = `${key}=${value}; ${
    age !== null ? `max-age=${age};` : ""
  } SameSite=Strict`;
};

export const clearCookie = (key) => {
  if (getCookie(key)) {
    document.cookie = `${key}=; max-age=0; SameSite=Strict`;
  }
};
